import { useMemo } from "react";
import { TreeComponent } from "@jsq/compliance-components";
import { QueryLoader, Text, Flex } from "@jsq/ds/core";
import { useGetProfileOwnershipTreeQuery } from "~/graphql/supergraphHooks";
import * as styles from "./styles_vanilla.css";
import { buildTreeData } from "./utils";

type Props = {
  rootProfileId: number;
};

export const ProfileTreeView = ({ rootProfileId }: Props) => {
  const result = useGetProfileOwnershipTreeQuery({
    variables: { profileId: rootProfileId },
    fetchPolicy: "cache-and-network",
  });

  const treeData = useMemo(
    () => buildTreeData(result.data?.complianceProfile),
    [result.data?.complianceProfile],
  );

  return (
    <QueryLoader result={result}>
      <Flex className={styles.wrapper}>
        <Flex className={styles.container}>
          {treeData ? (
            <div className={styles.treeContainer} role="tree">
              <TreeComponent data={treeData} rootEdgeStyle={{ dashWidth: 3, dashGap: 3 }} />
            </div>
          ) : (
            <Text variant="regular-md">
              No ownership structure is available for this profile.
            </Text>
          )}
        </Flex>
      </Flex>
    </QueryLoader>
  );
};
